// extracted by mini-css-extract-plugin
export default {"detailRowTitle":"DetailRow_detailRowTitle__IzHGl","detailRowValue":"DetailRow_detailRowValue__n3fJn"};